//@flow
import React from 'react'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Box from '@material-ui/core/Box'

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        animation: '$fadeIn 0.5s ease-out',
    },
    '@keyframes fadeIn': {
        from: { opacity: 0 },
        to: { opacity: 1 },
    },
    container: {
        position: 'relative',
        textAlign: 'center',
    },
    heroContent: {
        background: 'rgba(71, 85, 105, 0.7)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        border: '1px solid rgba(212, 175, 55, 0.2)',
        borderRadius: 24,
        padding: theme.spacing(6, 4),
        animation: '$scaleIn 0.5s ease-out',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
    },
    '@keyframes scaleIn': {
        from: {
            opacity: 0,
            transform: 'scale(0.9)',
        },
        to: {
            opacity: 1,
            transform: 'scale(1)',
        },
    },
    title: {
        background: 'linear-gradient(135deg, #CA9A2C 0%, #F3C817 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        fontFamily: '"Outfit", sans-serif',
        fontWeight: 700,
        marginBottom: theme.spacing(4),
    },
    spinnerContainer: {
        position: 'relative',
        display: 'inline-block',
    },
    spinner: {
        color: theme.palette.primary.light,
        animation: '$pulse 2s ease-in-out infinite',
    },
    '@keyframes pulse': {
        '0%, 100%': {
            opacity: 1,
        },
        '50%': {
            opacity: 0.6,
        },
    },
    spinnerGlow: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 60,
        height: 60,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(212, 175, 55, 0.3) 0%, transparent 70%)',
        animation: '$glow 2s ease-in-out infinite',
    },
    '@keyframes glow': {
        '0%, 100%': {
            transform: 'translate(-50%, -50%) scale(1)',
            opacity: 0.5,
        },
        '50%': {
            transform: 'translate(-50%, -50%) scale(1.3)',
            opacity: 0.8,
        },
    },
}));

function Spinner() {
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <Container maxWidth="sm" className={classes.container}>
                <div className={classes.heroContent}>
                    <Typography component="h1" variant="h4" className={classes.title} gutterBottom>
                        Loading...
                    </Typography>
                    <Box className={classes.spinnerContainer}>
                        <div className={classes.spinnerGlow} />
                        <CircularProgress
                            size={60}
                            thickness={4}
                            className={classes.spinner}
                            disableShrink
                        />
                    </Box>
                </div>
            </Container>
        </div>
    )
}

export default React.memo < {} > (Spinner)